import { EventSingle } from './event';

export const GET_PASS_SETTINGS = 'GET_PASS_SETTINGS';
export const GET_PASS_SETTINGS_SUCCESS = 'GET_PASS_SETTINGS_SUCCESS';
export const GET_PASS_SETTINGS_ERROR = 'GET_PASS_SETTINGS_ERROR';

export interface PassSettingsRequest {
    salesChannelId: number;
}

export interface PassSettingsSingle {
    id: number;
    sales_channel_id?: number;
    amount: string;
    currency?: string;
    title?: string;
    description?: string;
    start_date?: unknown;
    end_date?: unknown;
    is_enabled?: boolean;
    allow_multiple?: boolean;
    quantity?: number;
    stripe_product_id?: string;
    stripe_price_id?: string;
    max_quantity_per_purchase?: number;
    created?: unknown;
    updated?: unknown;
    events: EventSingle[];
    ends_this_month: boolean;
    timezone: string;
    remaining_passes: number;
}

export type PassSettingsWithSelectedQty = PassSettingsSingle & { currentQty: number };

export interface PassSettingsError {
    body?: {
        message?: string;
        status?: string;
    };
    message?: string;
    name?: string;
    status?: number;
}

export interface PassSettingsState {
    data: Array<PassSettingsSingle> | null;
    loading: boolean;
    error: PassSettingsError | null;
}

export interface GetPassSettingsAction {
    type: typeof GET_PASS_SETTINGS;
}

export interface GetPassSettingsSuccessAction {
    type: typeof GET_PASS_SETTINGS_SUCCESS;
    payload: Array<PassSettingsSingle>;
}

export interface GetPassSettingsErrorAction {
    type: typeof GET_PASS_SETTINGS_ERROR;
    payload: PassSettingsError;
}

export type PassSettingsAction = GetPassSettingsAction | GetPassSettingsSuccessAction | GetPassSettingsErrorAction;
